import React from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  LinearProgress,
  FormGroup,
  FormLabel,
} from "@material-ui/core";

import DateField from "components/_refactor/fields/date";
import Api from "lib/api/httpRequestHelper";
import moment from "moment";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { getUserName } from "utils/get-user-info";

const today = moment().format("YYYY-MM-DD");

export default function DialogConfirmacao({
  open,
  handleClose,
  idPedido,
  dataOrder,
  setPedidoSelecionado,
  setRefreshPage,
}) {
  const [dataRecebimento, setDataRecebimento] = React.useState(today);
  const [confirmando, setConfirmando] = React.useState(false);
  const [observacao, setObservacao] = React.useState("");
  const snackbar = useSnackbar();

  const submit = React.useCallback(async () => {
    setConfirmando(true);

    await Api.postParams(
      "set-order-recived-at-the-store",
      "order",
      "?idPedido=" +
        idPedido +
        "&dataRecebimento=" +
        (typeof dataRecebimento !== "string"
          ? dataRecebimento.format("YYYY-MM-DD")
          : dataRecebimento) +
        "&observacao=" +
        observacao,
      true
    )
      .then((res) => {
        const userName = getUserName();
        const userDetailVision = JSON.parse(
          localStorage.getItem("userDetailVision")
        );

        dataOrder.StatusRecebimento = "Recebido";
        dataOrder.DtRecebimento = res.Result.DtRecebimento;
        dataOrder.ObservacaoRecebimento = res.Result.Observacao;
        dataOrder.UsuarioRecebimento = userDetailVision
          ? userDetailVision?.Nome
          : userName;

        snackbar.showMessage(
          `Registro de recebimento do Pedido ${idPedido} realizado com sucesso!`,
          {
            severity: "success",
          }
        );

        setPedidoSelecionado(null);
        setRefreshPage(true);

        handleClose();
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(
          "Ocorreu um erro ao registrar o recebimento. Verifique os parâmetros informados.",
          {
            severity: "error",
          }
        );      })
      .finally(() => setConfirmando(false));
  }, [dataRecebimento, idPedido, dataOrder, observacao, snackbar, handleClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Confirmar recebimento do pedido {idPedido}
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent
        style={{ overflowY: "hidden", padding: "0 1.5rem 1.5rem" }}
      >
        <Typography id="alert-dialog-description" variant="h4">
          Preencha a data do recebimento e acrescente observações se necessário.
        </Typography>
        <br />
        <FormGroup>
          <DateField
            label="Data de Recebimento"
            onChange={setDataRecebimento}
            isValidDate={(current) => current.format("YYYY-MM-DD") <= today}
            value={dataRecebimento}
            disabled={confirmando}
            required={false}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Observações</FormLabel>
          <TextField
            placeholder="Observações do recebimento"
            multiline
            value={observacao}
            onChange={(event) => setObservacao(event.target.value)}
            variant="outlined"
            disabled={confirmando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 4000))
            }
          />
        </FormGroup>
        {confirmando && (
          <div>
            <span>Confirmando recebimento...</span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button component={Box} onClick={handleClose} disabled={confirmando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={submit}
          disabled={confirmando}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
